import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import ReactDOMServer from "react-dom/server";
import { StaticRouter } from "react-router-dom";
import { maybe } from "shared/maybe";
import { STANDARD_SPACING, TITLE_SEPARATOR } from "../config.js";
import useTitlePart from "../title/useTitlePart.js";
import Heading from "./Heading.js";
import ResponsiveStack from "./ResponsiveStack.js";
export default function PageTitle(props) {
    const flex = props.flex ?? "md";
    const title = ReactDOMServer.renderToStaticMarkup(_jsxs(StaticRouter, { location: "/", children: [props.title, maybe(props.subtitle, subtitle => _jsxs(Fragment, { children: [" ", TITLE_SEPARATOR, " ", subtitle] }))] })).replace(/<\/?[^>]+(>|$)/g, "");
    useTitlePart(title);
    return (_jsx(Fragment, { children: _jsxs("div", { className: "d-flex flex-column flex-" + flex + "-row align-items-" + flex + "-center justify-content-between gap-" + STANDARD_SPACING + " mb-" + STANDARD_SPACING, children: [_jsx(Heading, { title: props.title, subtitle: props.subtitle, level: props.level ?? "h1", margin: false }), _jsx(ResponsiveStack, { flex: flex, children: props.children })] }) }));
}
